import React from 'react';
import { Col, Label, Input } from 'reactstrap';


const clearValue = (e) => {
    if (!e.target) return;
    e.target.value = e.target.value.toString().replace(/\D/g,'');
}

export default ({ name, label, placeholder, required, sizeSm, sizeMd, sizeLg, _handleChange, value, maxLength }) => {
    sizeSm = !!sizeSm ? sizeSm : 0;
    sizeMd = !!sizeMd ? sizeMd : 0;
    sizeLg = !!sizeLg ? sizeLg : 0;

    return (
        <React.Fragment>
            <Col sm={sizeSm} md={sizeMd} lg={sizeLg}>
                <Label>{label}</Label>
                <Input
                    className="form-control"
                    type="text"
                    name={name}
                    required={required}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    onKeyDown={clearValue}
                    onKeyUp={clearValue}
                    onChange={_handleChange}
                    value={value}
                />
            </Col>
            </React.Fragment>
    )
};